// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.search-setting[data-v-34252a94] {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 12px;
  height: 382px;
  overflow: hidden;
}
.search-setting > div[data-v-34252a94] {
  display: flex;
  flex-direction: column;
  justify-items: flex-start;
  align-items: flex-start;
  gap: 8px;
  height: 100%;
}
.search-setting > div > div[data-v-34252a94] {
  width: 100%;
}
.search-setting label[data-v-34252a94] {
  text-align: center;
  width: 100%;
}
.search-setting .left[data-v-34252a94] {
  flex: 0.4;
}
.search-setting .left .top[data-v-34252a94] {
  height: 144px;
}
.search-setting .left .bottom[data-v-34252a94] {
  height: 200px;
}
.search-setting .right[data-v-34252a94] {
  flex: 0.6;
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  width: 100%;
}
.search-setting .right .box[data-v-34252a94] {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 10px;
  height: 100%;
}
.search-setting .right .box .box-left[data-v-34252a94] {
  flex: 0.4;
  height: 100%;
}
.search-setting .right .box .box-right[data-v-34252a94] {
  flex: 0.6;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 10px;
}
.search-setting .right .box .box-right > div[data-v-34252a94] {
  width: 100%;
  flex: 1;
}
`, "",{"version":3,"sources":["webpack://./src/views/BigDataSoftware/DataAnalysis/SearchSetting.vue","webpack://./SearchSetting.vue"],"names":[],"mappings":"AACA;EACE,WAAA;EACA,aAAA;EACA,8BAAA;EACA,uBAAA;EACA,SAAA;EACA,aAAA;EACA,gBAAA;ACAF;ADPA;EASI,aAAA;EACA,sBAAA;EACA,yBAAA;EACA,uBAAA;EACA,QAAA;EACA,YAAA;ACCJ;ADfA;EAgBM,WAAA;ACEN;ADlBA;EAoBI,kBAAA;EACA,WAAA;ACCJ;ADtBA;EAwBI,SAAA;ACCJ;ADzBA;EA0BM,aAAA;ACEN;AD5BA;EA6BM,aAAA;ACEN;AD/BA;EAiCI,SAAA;EACA,aAAA;EACA,2BAAA;EACA,sBAAA;EACA,uBAAA;EACA,QAAA;EACA,WAAA;ACCJ;ADxCA;EA0CM,WAAA;EACA,aAAA;EACA,8BAAA;EACA,uBAAA;EACA,SAAA;EACA,YAAA;ACCN;ADhDA;EAiDQ,SAAA;EACA,YAAA;ACER;ADpDA;EAqDQ,SAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,2BAAA;EACA,uBAAA;EACA,SAAA;ACER;AD7DA;EA6DU,WAAA;EACA,OAAA;ACGV","sourcesContent":["\n.search-setting {\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: 12px;\n  height: 382px;\n  overflow: hidden;\n  > div {\n    display: flex;\n    flex-direction: column;\n    justify-items: flex-start;\n    align-items: flex-start;\n    gap: 8px;\n    height: 100%;\n    > div {\n      width: 100%;\n    }\n  }\n  label {\n    text-align: center;\n    width: 100%;\n  }\n  .left {\n    flex: 0.4;\n    .top {\n      height: 144px;\n    }\n    .bottom {\n      height: 200px;\n    }\n  }\n  .right {\n    flex: 0.6;\n    display: flex;\n    justify-content: flex-start;\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 8px;\n    width: 100%;\n\n    .box {\n      width: 100%;\n      display: flex;\n      justify-content: space-between;\n      align-items: flex-start;\n      gap: 10px;\n      height: 100%;\n      .box-left {\n        flex: 0.4;\n        height: 100%;\n      }\n      .box-right {\n        flex: 0.6;\n        height: 100%;\n        display: flex;\n        flex-direction: column;\n        justify-content: flex-start;\n        align-items: flex-start;\n        gap: 10px;\n        > div {\n          width: 100%;\n          flex: 1;\n        }\n      }\n    }\n  }\n}\n",".search-setting {\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: 12px;\n  height: 382px;\n  overflow: hidden;\n}\n.search-setting > div {\n  display: flex;\n  flex-direction: column;\n  justify-items: flex-start;\n  align-items: flex-start;\n  gap: 8px;\n  height: 100%;\n}\n.search-setting > div > div {\n  width: 100%;\n}\n.search-setting label {\n  text-align: center;\n  width: 100%;\n}\n.search-setting .left {\n  flex: 0.4;\n}\n.search-setting .left .top {\n  height: 144px;\n}\n.search-setting .left .bottom {\n  height: 200px;\n}\n.search-setting .right {\n  flex: 0.6;\n  display: flex;\n  justify-content: flex-start;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 8px;\n  width: 100%;\n}\n.search-setting .right .box {\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: 10px;\n  height: 100%;\n}\n.search-setting .right .box .box-left {\n  flex: 0.4;\n  height: 100%;\n}\n.search-setting .right .box .box-right {\n  flex: 0.6;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  align-items: flex-start;\n  gap: 10px;\n}\n.search-setting .right .box .box-right > div {\n  width: 100%;\n  flex: 1;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
